// extracted by mini-css-extract-plugin
export default {"wrapper":"aFreS7","external":"bFreS7","hiddenBorder":"cFreS7","floatImg":"dFreS7","displayFlex":"eFreS7","linkContainer":"fFreS7","buttonContainer":"gFreS7"};